/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener('DOMContentLoaded', function() {  
const setupStickyCartCheckout = () => {
    const normalButton = document.getElementById('Btn__main__Cart__Checkout');
    const stickyButton = document.getElementById('checkout--sticky');
    
    if (!normalButton || !stickyButton) {
      return;
    }
    
    if (normalButton.closest('.Drawer')) {
      return;
    }
    
    stickyButton.style.display = 'none';
    
    let isStickyVisible = false;
    
    const originalOffsetTop = normalButton.getBoundingClientRect().top + window.pageYOffset;
    const originalOffsetBottom = originalOffsetTop + normalButton.offsetHeight; 
    
    const handleScroll = () => {
      if (!document.contains(normalButton)) {
          window.removeEventListener('scroll', throttledScroll);
          return;
      }
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const viewportBottom = scrollTop + window.innerHeight;
      
      const isNormalButtonInView = 
          (originalOffsetBottom > scrollTop) && 
          (originalOffsetTop < viewportBottom);

      const shouldShowSticky = !isNormalButtonInView;
      
      if (shouldShowSticky && !isStickyVisible) {
        stickyButton.style.display = 'block';
        isStickyVisible = true;
      } else if (!shouldShowSticky && isStickyVisible) {
        stickyButton.style.display = 'none';
        isStickyVisible = false;
      }
    };
    
    let ticking = false;
    const throttledScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    
    window.removeEventListener('scroll', throttledScroll); 
    window.addEventListener('scroll', throttledScroll);
  };
  
  setTimeout(() => {
    setupStickyCartCheckout();
  }, 100);
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.id === 'Btn__main__Cart__Checkout' || 
                node.id === 'checkout--sticky' ||
                (node.querySelector && (node.querySelector('#Btn__main__Cart__Checkout') || node.querySelector('#checkout--sticky')))) {
              setTimeout(setupStickyCartCheckout, 50);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  

  /* Add to cart Booster */
  if (document.body.classList.contains('template-product')) {
    $(window).on('scroll', function () {
      $('.Product__FloatingInner').toggleClass(
        'is-floating',
        $(window).scrollTop() > 0 && $(window).width() <= 640
      );
    });
  }

  // Option select
  window.addEventListener('click', (e) => {
    const el = e.target;
    if (el.classList.contains('canadian-select__options__option')) {
      console.log('canadian clicked');
      const selectedHandle = el.dataset.value;
      const selectedValue = el.innerText;
      const container = el.parentElement.parentElement;
      const realSelectedEl = container.querySelector('[selected');
      const displaySelectedEl = container.querySelector(
        '.canadian-select__selected'
      );
      displaySelectedEl.innerHTML = selectedValue;
      realSelectedEl.innerHTML = selectedValue;
      realSelectedEl.setAttribute('value', selectedHandle);
    }
  });

  /* eslint-disable max-len */

    const collapsibles = Array.from(
      document.getElementsByClassName('collapsible')
    );

    collapsibles.forEach((collapsible, i) => {
      collapsible.dataset.collapsedHeight = collapsible.clientHeight;
      collapsible.dataset.openedHeight = collapsible.scrollHeight;
      collapsible.dataset.collapsed = 'true';

      let collapsibleParent = null;

      if (collapsible.parentElement.classList.contains('collapsible')) {
        collapsibleParent = collapsible.parentElement;
      }

      if (
        collapsible.parentElement.parentElement.classList.contains(
          'collapsible'
        )
      ) {
        collapsibleParent = collapsible.parentElement.parentElement;
      }

      collapsible.addEventListener('click', (e) => {
        const isCanadianSelect = e.target.className.includes('canadian-select');
        !isCanadianSelect && e.stopPropagation();

        const clickedCollapse =
          e.target === collapsible
            ? collapsible
            : e.target.closest('.collapsible');

        const isMobile = window.innerWidth < 768;
        if (
          clickedCollapse.classList.contains('collapsible--mobile-only') &&
          !isMobile
        ) {
          return;
        }

        const isClosed = clickedCollapse.dataset.collapsed === 'true';
        const openHeightGreaterThanScrollHeight =
          clickedCollapse.dataset.openedHeight > clickedCollapse.scrollHeight;
        const dataUnset = clickedCollapse.dataset.openedHeight === '0';

        if (dataUnset || (isClosed && openHeightGreaterThanScrollHeight)) {
          clickedCollapse.dataset.collapsedHeight =
            clickedCollapse.clientHeight;
          clickedCollapse.dataset.openedHeight = clickedCollapse.scrollHeight;
        } else {
          clickedCollapse.dataset.openedHeight = clickedCollapse.scrollHeight;
        }

        if (isClosed) {
          clickedCollapse.style.height = `${clickedCollapse.dataset.openedHeight}px`;
          clickedCollapse.dataset.collapsed = 'false';

          if (collapsibleParent) {
            const newcollapsibleParentOpenHeight =
              parseInt(collapsibleParent.dataset.openedHeight, 10) +
              (clickedCollapse.dataset.openedHeight -
                clickedCollapse.dataset.collapsedHeight);
            collapsibleParent.style.height = `${newcollapsibleParentOpenHeight}px`;
            collapsibleParent.dataset.openedHeight = newcollapsibleParentOpenHeight;
          }
        } else {
          clickedCollapse.style.height = `${clickedCollapse.dataset.collapsedHeight}px`;
          clickedCollapse.dataset.collapsed = 'true';

          if (collapsibleParent) {
            const newcollapsibleParentOpenHeight =
              parseInt(collapsibleParent.dataset.openedHeight, 10) -
              (clickedCollapse.dataset.openedHeight -
                clickedCollapse.dataset.collapsedHeight);
            collapsibleParent.style.height = `${newcollapsibleParentOpenHeight}px`;
            collapsibleParent.dataset.openedHeight = newcollapsibleParentOpenHeight;
          }
        }
      });

      if (i === collapsibles.length - 1) {
        const event = new Event('collapsiblesLoaded');
        window.dispatchEvent(event);
      }
    });
});

(function () {
  function wrapOrphanListItems(root) {
    if (!root) {
      return;
    }

    var elements = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));

    for (var i = elements.length - 1; i >= 0; i--) {
      var parent = elements[i];
      var tag = parent.tagName;

      if (tag === 'UL' || tag === 'OL' || tag === 'MENU') {
        continue;
      }

      var run = [];

      function flush() {
        if (!run.length) {
          return;
        }

        var ul = document.createElement('ul');
        parent.insertBefore(ul, run[0]);

        for (var r = 0; r < run.length; r++) {
          ul.appendChild(run[r]);
        }

        run = [];
      }

      var nodes = Array.prototype.slice.call(parent.childNodes);

      for (var n = 0; n < nodes.length; n++) {
        var node = nodes[n];

        if (node.nodeType === 1 && node.tagName === 'LI') {
          run.push(node);
        } else if (node.nodeType === 3 && !String(node.textContent).replace(/\u00a0/g, ' ').trim()) {
          continue;
        } else {
          flush();
        }
      }

      flush();
    }
  }

  function wrapAll() {
    var roots = document.querySelectorAll('.Rte, .description__content, .tabcontent, .ProductMeta__Description');

    for (var i = 0; i < roots.length; i++) {
      wrapOrphanListItems(roots[i]);
    }

    var captionSrc = '';
    var existingCaption = document.querySelector('video track[kind="captions"]');

    if (existingCaption) {
      captionSrc = existingCaption.getAttribute('src') || '';
    }

    var videos = document.querySelectorAll('video');

    for (var vid = 0; vid < videos.length; vid++) {
      var videoEl = videos[vid];

      if (!videoEl.querySelector('track[kind="captions"]') && captionSrc) {
        var track = document.createElement('track');
        track.kind = 'captions';
        track.srclang = 'en';
        track.label = 'No spoken audio';
        track.src = captionSrc;
        videoEl.appendChild(track);
      }
    }

    var videoFallbacks = document.querySelectorAll('video > img:not([alt])');

    for (var v = 0; v < videoFallbacks.length; v++) {
      var img = videoFallbacks[v];
      var video = img.parentElement;
      var label = '';

      if (video) {
        label = video.getAttribute('aria-label') || video.getAttribute('title') || '';
      }

      if (!label) {
        var heading = document.querySelector('.ProductMeta__Title, h1');
        label = heading ? heading.textContent.trim() : 'Product video';
      }

      img.setAttribute('alt', label);
    }

    var tabHeadings = document.querySelectorAll('.description__tabs__tab h1, .description__tabs__tab h2, .description__tabs__tab h3, .description__tabs__tab h4, .description__tabs__tab h5, .description__tabs__tab h6');

    for (var t = 0; t < tabHeadings.length; t++) {
      var heading = tabHeadings[t];
      var label = document.createElement('span');

      while (heading.firstChild) {
        label.appendChild(heading.firstChild);
      }

      heading.parentNode.replaceChild(label, heading);
    }

    var faqHeadings = document.querySelectorAll('.faqs-answer h4');

    for (var f = 0; f < faqHeadings.length; f++) {
      var oldHeading = faqHeadings[f];
      var newHeading = document.createElement('h3');

      newHeading.className = oldHeading.className;

      while (oldHeading.firstChild) {
        newHeading.appendChild(oldHeading.firstChild);
      }

      oldHeading.parentNode.replaceChild(newHeading, oldHeading);
    }
  }

  window.CurvyA11y = {
    wrapOrphanListItems: wrapOrphanListItems,
    wrapAll: wrapAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapAll);
  } else {
    wrapAll();
  }
})();

(function () {
  function isThirdPartyHidden(el) {
    return el.closest('.yotpo-widget-loyalty-floater-widget, #shop-hcaptcha-badge-container');
  }

  function syncInert(el) {
    if (!el || isThirdPartyHidden(el)) {
      return;
    }

    if (el.getAttribute('aria-hidden') === 'true') {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  function protectSkipLink() {
    var skip = document.querySelector('.PageSkipLink');

    if (skip && skip.hasAttribute('aria-hidden')) {
      skip.removeAttribute('aria-hidden');
    }
  }

  function init() {
    protectSkipLink();
    syncInert(document.querySelector('.PageContainer'));

    var skip = document.querySelector('.PageSkipLink');
    var page = document.querySelector('.PageContainer');

    if (skip) {
      new MutationObserver(protectSkipLink).observe(skip, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }

    if (page) {
      new MutationObserver(function () {
        syncInert(page);
      }).observe(page, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  var scheduled = false;

  function matches(el, selector) {
    return el && el.nodeType === 1 && el.matches && el.matches(selector);
  }

  function collect(root, selector) {
    var list = [];

    if (matches(root, selector)) {
      list.push(root);
    }

    if (root && root.querySelectorAll) {
      var found = root.querySelectorAll(selector);

      for (var i = 0; i < found.length; i++) {
        list.push(found[i]);
      }
    }

    return list;
  }

  function patchYotpoA11y(root) {
    root = root || document;

    var dates = collect(root, '.yotpo-review-date[aria-label]');
    var i;

    for (i = 0; i < dates.length; i++) {
      dates[i].removeAttribute('aria-label');
    }

    var switchers = collect(root, '.yotpo-campaign-switcher-wrapper[aria-label]');

    for (i = 0; i < switchers.length; i++) {
      switchers[i].removeAttribute('aria-label');
    }

    var pagers = collect(root, '.yotpo-pager[role="menu"]');

    for (i = 0; i < pagers.length; i++) {
      var pager = pagers[i];
      pager.removeAttribute('role');

      var items = pager.querySelectorAll('[role="menuitem"]');

      for (var n = 0; n < items.length; n++) {
        items[n].removeAttribute('role');
      }
    }

    var tabBoxes = collect(root, '.yotpo-nav-primary, .yotpo-popup-box-small');

    for (i = 0; i < tabBoxes.length; i++) {
      var box = tabBoxes[i];
      var list = box.querySelector(':scope > ul, ul');

      if (!list || !box.querySelector('[role="tab"]')) {
        continue;
      }

      if (!box.getAttribute('role')) {
        box.setAttribute('role', 'tablist');
      }

      if (box.getAttribute('role') === 'tablist' && !box.getAttribute('aria-label')) {
        box.setAttribute('aria-label', 'Testimonials tabs');
      }

      if (list.getAttribute('role') === 'tablist') {
        list.removeAttribute('role');
        list.removeAttribute('aria-label');
      }

      list.setAttribute('role', 'presentation');
    }
  }

  function schedule(target) {
    if (scheduled) {
      return;
    }

    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      patchYotpoA11y(target || document);
    }, 80);
  }

  function init() {
    patchYotpoA11y(document);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type === 'childList') {
          for (var a = 0; a < mutation.addedNodes.length; a++) {
            if (mutation.addedNodes[a].nodeType === 1) {
              schedule(document);
              return;
            }
          }
        } else if (mutation.type === 'attributes' && mutation.target) {
          if (
            matches(mutation.target, '.yotpo-review-date[aria-label], .yotpo-campaign-switcher-wrapper[aria-label], .yotpo-pager[role="menu"], .yotpo-nav-primary, .yotpo-popup-box-small, .yotpo-popup-box-small > ul, .yotpo-nav-primary > ul')
          ) {
            schedule(document);
            return;
          }
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'role']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();